import React from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import {
  CloseCircleOutlined
} from '@ant-design/icons';
import './index.css';

class Message extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillReceiveProps (nextProps) {
  }
  render () {
    return (
      <div className='home_message box-padding-horizontal' style={{ display: this.props.show && (!this.props.close_header_message) ? "flex" : "none" }}>
        <div className="close_btn">
        </div>
        <div className="message_text" onClick={this.titleClick.bind(this)}>{this.props.text}</div>
        <div className="close_btn" onClick={this.closeMessage.bind(this)}>
          <CloseCircleOutlined style={{ color: "white" }} />
        </div>
      </div>
    );
  }
  closeMessage () {
    this.props.CLOSE_HEADER_MESSAGE(true);
  }
  titleClick () {
    if (this.props.id && this.props.id != "") {
      window.location.href = "#/trendinfo/" + this.props.id;
    } else {
      message.info("该动态暂无具体内容");
    }
  }
}
function mapStateToProps (state) {
  return {
    close_header_message: state.close_header_message
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    CLOSE_HEADER_MESSAGE: (bool) => {
      dispatch({ type: 'CLOSE_HEADER_MESSAGE', close_header_message: bool })
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Message);